import { useState } from 'react'
import { Card, Form, Input, Button, message } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { staffAuthApi } from '../services/api'

function Login() {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const onFinish = async (values: { username: string; password: string }) => {
    setLoading(true)
    try {
      // 调用后端登录API
      const res: any = await staffAuthApi.login({
        username: values.username,
        password: values.password
      })

      if (res.code === 200) {
        // 保存token
        localStorage.setItem('accessToken', res.data.token)
        localStorage.setItem('user', JSON.stringify(res.data.user))
        
        // 保存权限信息（包含 is_super_admin, roles, permissions, menu_paths）
        const permData = {
          is_super_admin: res.data.is_super_admin || false,
          roles: res.data.roles || [],
          permissions: res.data.permissions || [],
          menu_paths: res.data.menu_paths || []
        }
        localStorage.setItem('userPermissions', JSON.stringify(permData))
        
        message.success('登录成功')
        navigate('/dashboard')
      } else {
        message.error(res.message || '登录失败')
      }
    } catch (error: any) {
      console.error('登录错误:', error)
      message.error(error.response?.data?.message || '登录失败，请检查网络')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #55266c 0%, #7c3a8f 100%)'
    }}>
      <Card style={{ width: 400, borderRadius: 8 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <img 
            src="/logo.jpg" 
            alt="智厨云" 
            style={{ width: 80, height: 80, marginBottom: 16, borderRadius: 8 }}
            onError={(e) => {
              e.currentTarget.style.display = 'none'
            }}
          />
          <h1 style={{ margin: 0, color: '#55266c' }}>智厨云</h1>
          <p style={{ color: '#666', marginTop: 8 }}>后厨承包与净菜配送系统</p>
        </div>
        
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名 / 手机号" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loading}
              block
              style={{ backgroundColor: '#55266c' }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
        
        <div style={{ textAlign: 'center', color: '#999', fontSize: 12 }}>
          默认账号: admin / admin123
        </div>
      </Card>
    </div>
  )
}

export default Login
